import React from "react";
import { Modal, Button, ModalProps } from "antd";

interface BaseModalProps extends Omit<ModalProps, "onCancel"> {
    visible: boolean;
    onClose: () => void;
    title: React.ReactNode;
    content?: React.ReactNode;
}

const BaseModal: React.FC<BaseModalProps> = ({
    visible,
    onClose,
    title,
    content,
    children,
    width = 800,
    closable = false,
    className = "base-modal",
    ...restProps
}) => {
    return (
        <Modal
            title={
                <div className="base-modal-title">
                    <span style={{ width: "300px" }}>{title}</span>
                    <Button key="close" onClick={onClose} className="secondary base-modal-close">
                        Close
                    </Button>
                </div>
            }
            visible={visible}
            onCancel={onClose}
            width={width}
            closable={closable}
            className={className}
            {...restProps}
        >
            {content || children}
        </Modal>
    );
};

export default BaseModal;
